import React, { FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../store';
import { setFakeData, setShowFakeDataForm } from '../store/application/actions';
import FakeData from '../components/FakeData';
import { DeviceType, ProductInfo } from 'sofa-reborn-react';

const FakeDataContainer: FC = () => {
	const productInfo = useSelector<RootState, ProductInfo | null>(
		(state) => state.products.productInfo
	);
	const deviceType = useSelector<RootState, DeviceType>((state) => state.deviceInfo.deviceType);

	const dispatch = useDispatch<AppDispatch>();

	const onCloseFakeDataForm = (): void => {
		dispatch(setShowFakeDataForm(false));
	};

	const onLoadFakeData = (e): void => {
		dispatch(setFakeData(e.detail.updatedProducts));
		// Used for test to see whats changed
		// eslint-disable-next-line no-console
		console.log('fakeData', e.detail.updatedProducts);
		location.reload();
	};

	return (
		<FakeData
			deviceType={deviceType}
			productInfo={productInfo}
			onCloseFakeDataForm={onCloseFakeDataForm}
			onLoadFakeData={onLoadFakeData}
		/>
	);
};

export default FakeDataContainer;
